/**
 * `/oauth/connections[/:id]` — where a connected app's page used to live, outside the app. It moved into Settings →
 * Connected apps (owner, 2026-10-16: it looked disconnected from Papan and had no way back); these URLs redirect there
 * so links Claude already handed out (`papan_manage_connection`, whoami, the "not approved for that org" errors) keep
 * working. Settings handles sign-in like any other page.
 */
import { Navigate, useParams } from 'react-router-dom'

export function McpConnectionsPage() {
  const { id } = useParams<{ id?: string }>()
  return <Navigate to={id ? `/settings/connected-apps/${encodeURIComponent(id)}` : '/settings/connected-apps'} replace />
}
